export const getWord = (word) => {
    if (!word) return '';
    if (word === 'PRACTITIONER') return 'assignees__user__id__in';
    if (word === 'TREATMENT') return 'treatment_item__name__in';
    if (word === 'SOURCE_REFERRAL') return 'lead_source__referral__in';
    if (word === 'DATE_RANGE') return 'created_at__range';
    if (word === 'SOURCE_TYPE') return 'source__type';
    if (word === 'CATEGORY') return 'category__in';
    return word.toLowerCase();
};